var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMasterCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 59,
    viewBox: "0 0 85 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MasterCard/Logo"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.535461,
    y: 0.550477,
    width: 83,
    height: 57,
    rx: 3.5,
    transform: "rotate(-0.03491 0.535461 0.550477)",
    stroke: "#EFF0F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M49.7512 42.0355L34.76 42.0447L34.7437 15.2715L49.7349 15.2624L49.7512 42.0355Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M35.7126 28.6553C35.7093 23.2242 38.2652 18.3848 42.2482 15.2647C39.3328 12.9866 35.6543 11.6281 31.6574 11.6306C22.1953 11.6363 14.5298 19.2642 14.5355 28.6682C14.5413 38.0721 22.216 45.6906 31.6782 45.6849C35.675 45.6824 39.3519 44.3195 42.2645 42.0379C38.2777 38.9226 35.7159 34.0863 35.7126 28.6553Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M69.962 28.6356C69.9677 38.0396 62.3022 45.6675 52.8401 45.6732C48.8433 45.6757 45.1648 44.3172 42.2483 42.0391C46.2323 38.919 48.7883 34.0796 48.785 28.6485C48.7816 23.2175 46.2198 18.3812 42.232 15.2659C45.1457 12.9843 48.8225 11.6214 52.8194 11.6189C62.2815 11.6132 69.9563 19.2317 69.962 28.6356Z",
    fill: "#F79E1B"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCard);
export default __webpack_public_path__ + "static/media/MasterCard.36bd89a5.svg";
export { ForwardRef as ReactComponent };